
import { getCustomServerSideProps, GetServerSidePropsContext } from '@/utils/serverSide';
import View from '@/views/contact';

export default View;

export const getServerSideProps = async (
    context: GetServerSidePropsContext,
) => {
    return getCustomServerSideProps(
        context,
        {
            config: {
                layout: {
                    name: 'public',
                },
                protected: false,
            },
        },
        {
            redirectIfLogged: false,
            seoConfig: {
                title: 'Contact Us',
            },
        },
    );
};
